const Blockly = require('blockly');
const dataAccessMethods = require('../../../../dataAccessMethods');
const setupAddCodeProperties = require('../../../../helpers/addCodeProperties');

const TOOLTIP =
    'Filter a given control\'s contents based on the "Splash" record: the one selected made by a user during use case startup (often in a dialog similar to a splash screen).';

function addBlockSpecificFields(color, blocklyBlock, mdcBlock, line1OfInputs) {
    let workspace = blocklyBlock.workspace;
    let blockId = blocklyBlock.id;

    blocklyBlock.setTooltip(TOOLTIP);
    //set inputs to be arranged vertically.
    //Meaning each (dummy)input starts a new line
    blocklyBlock.setInputsInline(false);
    line1OfInputs
        .appendField('|   Optional Namespace:')
        .appendField(new Blockly.FieldDropdown(() => dataAccessMethods.getNamespaces(true)), 'namespace')
        .appendField('  Optional Relation:')
        .appendField(
            new Blockly.FieldDropdown(() => dataAccessMethods.getRelations(workspace, blockId, true)),
            'relation'
        );
}
function convertCustomFieldsToCode(code, blocklyBlock) {
    const addCodeProperties = setupAddCodeProperties(code, blocklyBlock);
    addCodeProperties(['namespace', 'relation']);
    return code;
}

module.exports = { addBlockSpecificFields, convertCustomFieldsToCode };
